import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  expandedSections: string[];
  language: string;
  theme: 'light' | 'dark';
}

const initialState: UIState = {
  sidebarOpen: true,
  expandedSections: ['internal-transfers'],
  language: localStorage.getItem('language') || 'en',
  theme: 'light'
};

/** TODO: move to entities later */
/** @deprecated */
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    toggleSection: (state, action: PayloadAction<string>) => {
      const sectionId = action.payload;
      const index = state.expandedSections.indexOf(sectionId);
      if (index === -1) {
        state.expandedSections.push(sectionId);
      } else {
        state.expandedSections.splice(index, 1);
      }
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    }
  }
});

export const { toggleSidebar, setSidebarOpen, toggleSection, setLanguage, setTheme } = uiSlice.actions;

/** TODO: move to entities later */
/** @deprecated */
export default uiSlice.reducer;
